import { Link } from 'react-router-dom';
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function NavMenuContent({
  menuOpen,
  setMenuOpen
}: {
  menuOpen: boolean;
  setMenuOpen: (v: boolean) => void;
}) {
  const {
    menuItems,
    loading
  } = useMenu();
  return <>
      <div className="hidden md:flex flex-1 items-center justify-end gap-1">
        <nav className="flex items-center gap-1" aria-label="Main navigation">
          {!loading && menuItems.map(item => <Link key={item.id} to={item.href || "#"} className="relative group px-5 py-2 rounded-full text-foreground transition-colors duration-200 hover:text-primary" style={{
          fontFamily: "'DM Sans', sans-serif",
          fontSize: "0.82rem",
          fontWeight: 500,
          letterSpacing: "0.12em",
          textTransform: "uppercase"
        }}>
              <span className="absolute inset-0 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-200" style={{
            background: "oklch(0.97 0.03 55)"
          }} />
              <span className="relative">{item.label}</span>
            </Link>)}
        </nav>

        <div className="w-px h-8 bg-border mx-4" />

        <div className="flex items-center gap-3">
          <Link to="https://facebook.com" aria-label="Facebook" className="text-muted-foreground hover:text-foreground transition-colors duration-200" style={{
          fontFamily: "'DM Sans', sans-serif",
          fontSize: "0.7rem",
          letterSpacing: "0.15em",
          textTransform: "uppercase",
          fontWeight: 500
        }}>
            Facebook
          </Link>
          <Link to="https://twitter.com" aria-label="Twitter" className="text-muted-foreground hover:text-foreground transition-colors duration-200" style={{
          fontFamily: "'DM Sans', sans-serif",
          fontSize: "0.7rem",
          letterSpacing: "0.15em",
          textTransform: "uppercase",
          fontWeight: 500
        }}>
            Twitter
          </Link>
          <Link to="https://instagram.com" aria-label="Instagram" className="text-muted-foreground hover:text-foreground transition-colors duration-200" style={{
          fontFamily: "'DM Sans', sans-serif",
          fontSize: "0.7rem",
          letterSpacing: "0.15em",
          textTransform: "uppercase",
          fontWeight: 500
        }}>
            Instagram
          </Link>
          <Link to="https://tripadvisor.com" aria-label="Trip Advisor" className="text-muted-foreground hover:text-foreground transition-colors duration-200" style={{
          fontFamily: "'DM Sans', sans-serif",
          fontSize: "0.7rem",
          letterSpacing: "0.15em",
          textTransform: "uppercase",
          fontWeight: 500
        }}>
            Trip Advisor
          </Link>
        </div>
      </div>

      <div className="flex md:hidden items-center ml-auto">
        <Button variant="ghost" size="sm" onClick={() => setMenuOpen(!menuOpen)} aria-label="Toggle menu" className="text-foreground">
          <span className="flex flex-col gap-1.5 w-5">
            <span className={`block h-0.5 bg-foreground transition-all duration-300 origin-center ${menuOpen ? "rotate-45 translate-y-2" : ""}`} />
            <span className={`block h-0.5 bg-foreground transition-all duration-300 ${menuOpen ? "opacity-0" : ""}`} />
            <span className={`block h-0.5 bg-foreground transition-all duration-300 origin-center ${menuOpen ? "-rotate-45 -translate-y-2" : ""}`} />
          </span>
        </Button>
      </div>

      {menuOpen && <div className="md:hidden border-t border-border bg-background px-6 py-6 flex flex-col gap-4 animate-in fade-in slide-in-from-top-2 duration-200">
          <nav className="flex flex-col gap-2">
            {!loading && menuItems.map(item => <Link key={item.id} to={item.href || "#"} className="py-2 text-foreground hover:text-primary transition-colors duration-150" style={{
          fontFamily: "'DM Sans', sans-serif",
          fontSize: "0.85rem",
          fontWeight: 500,
          letterSpacing: "0.15em",
          textTransform: "uppercase"
        }} onClick={() => setMenuOpen(false)}>
                {item.label}
              </Link>)}
          </nav>
          <div className="border-t border-border pt-4 flex flex-wrap gap-4">
            {["Facebook", "Twitter", "Instagram", "Trip Advisor"].map(s => <Link key={s} to="#" className="text-muted-foreground hover:text-foreground transition-colors duration-150" style={{
          fontFamily: "'DM Sans', sans-serif",
          fontSize: "0.7rem",
          letterSpacing: "0.14em",
          textTransform: "uppercase",
          fontWeight: 500
        }}>
                {s}
              </Link>)}
          </div>
        </div>}
    </>;
}
export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  return <header id="header" className="relative w-full overflow-hidden bg-background">
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;700;900&family=DM+Sans:wght@300;400;500&display=swap');`}</style>

      <div className="absolute inset-0 pointer-events-none" style={{
      background: "radial-gradient(ellipse 80% 60% at 50% 0%, rgba(180,100,30,0.08) 0%, transparent 70%)"
    }} />

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex items-stretch min-h-[88px] gap-8">

          <div className="flex items-center gap-3 flex-shrink-0 py-3">
            <Link to="/" aria-label="sanluistortilleria home">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/985960/img/original-color-logo-transparent-background.png" alt="sanluistortilleria" className="w-full h-auto max-w-[56px] object-contain drop-shadow-sm" />
            </Link>
            <div className="flex flex-col justify-center">
              <span className="text-foreground leading-tight tracking-wide" style={{
              fontFamily: "'Playfair Display', serif",
              fontSize: "1.1rem",
              fontWeight: 700,
              letterSpacing: "0.04em"
            }}>
                San Luis
              </span>
              <span className="text-muted-foreground uppercase" style={{
              fontFamily: "'DM Sans', sans-serif",
              fontSize: "0.58rem",
              fontWeight: 500,
              letterSpacing: "0.22em"
            }}>
                Tortilleria
              </span>
              <span className="mt-0.5" style={{
              fontFamily: "'DM Sans', sans-serif",
              fontSize: "0.5rem",
              fontWeight: 300,
              letterSpacing: "0.18em",
              color: "oklch(0.6 0.12 55)",
              textTransform: "uppercase"
            }}>
                Tortilla made daily
              </span>
            </div>
          </div>

          <MenuProvider menu_id="27">
            <NavMenuContent menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
          </MenuProvider>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-px" style={{
      background: "linear-gradient(to right, transparent, oklch(0.7 0.08 55 / 0.4) 30%, oklch(0.7 0.08 55 / 0.4) 70%, transparent)"
    }} />
    </header>;
}